import {
  quantityFromSiteUnits,
  siteUnits,
} from '@calculations/utilities/selling-uom';

import {
  onPartQuantityChange,
  onServiceChargeQuantityChange,
} from '../../calculations/recalculate';
import { validateDuplicateQuotePriceQuantities } from '../../validations/duplicate-quantities';
import { validateQuantity } from '../../validations/quantity';
import { PriceFieldHandlerParams } from './types';

export function handlePartQuantityFieldChange({
  state,
  quoteLineUuid,
  quotePriceUuid,
  value,
  priceStrategyConfigs,
}: PriceFieldHandlerParams) {
  const enteredQuantity = validateQuantity(state, {
    quoteLineUuid,
    quotePriceUuid,
    quantity: value,
  });

  if (!enteredQuantity) {
    return;
  }

  /**
   * Validation runs against what the user typed, which is in the site's selling
   * unit of measure. Everything downstream — state, calculations, persistence —
   * is in eaches.
   */
  const quantity = quantityFromSiteUnits(siteUnits(enteredQuantity), {
    sellingUnitOfMeasure: state.sellingUnitOfMeasure,
  });

  onPartQuantityChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    quantity,
    priceStrategyConfigs,
  });

  validateDuplicateQuotePriceQuantities(state, {
    quantity,
    quoteLineUuid,
    quotePriceUuid,
  });
}

/**
 * Deliberately unconverted. A service charge quantity counts services, not
 * pieces, so it is dimensionless with respect to the selling unit of measure —
 * a quantity of 1 means one service at every site.
 */
export function handleServiceQuantityFieldChange({
  state,
  quoteLineUuid,
  quotePriceUuid,
  value,
}: PriceFieldHandlerParams) {
  const quantity = validateQuantity(state, {
    quoteLineUuid,
    quotePriceUuid,
    quantity: value,
    isServiceCharge: true,
  });

  if (!quantity) {
    return;
  }

  onServiceChargeQuantityChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    quantity,
  });

  validateDuplicateQuotePriceQuantities(state, {
    quantity,
    quoteLineUuid,
    quotePriceUuid,
  });
}
